import { useChannelsHealthAnalytics } from '../../hooks/use-analytics';
import { Badge } from '../ui/badge';
import { Skeleton } from '../ui/skeleton';

export function ChannelsHealthWidget() {
  const { data, isLoading, isError } = useChannelsHealthAnalytics();

  if (isLoading) return <Skeleton className="h-56 w-full" />;
  if (isError) return <div className="text-sm text-red-600">Не удалось загрузить здоровье каналов.</div>;

  const items = data?.items ?? [];
  if (items.length === 0) return <div className="p-4 text-sm text-muted-fg">Нет подключённых каналов</div>;

  return (
    <div className="rounded border border-border p-4">
      <h2 className="mb-3 font-semibold">Здоровье каналов</h2>
      <table className="w-full text-sm">
        <thead className="text-left text-xs uppercase text-muted-fg">
          <tr>
            <th className="py-1">Канал</th>
            <th className="py-1">Статус</th>
            <th className="py-1">Окно 7/4ч</th>
            <th className="py-1">Инциденты 7д</th>
            <th className="py-1">Отписки 24ч</th>
          </tr>
        </thead>
        <tbody>
          {items.map((c) => (
            <tr key={c.channelId} className="border-t border-border">
              <td className="py-1">{c.title ?? c.channelId}</td>
              <td className="py-1">
                <Badge tone={c.status === 'active' ? 'success' : 'danger'}>{c.status}</Badge>
              </td>
              <td className="py-1 text-xs">
                {c.usage.window.used}/{c.usage.window.max ?? '∞'}
              </td>
              <td className="py-1 text-xs">{c.incidents7d}</td>
              <td className="py-1 text-xs">{Math.round(c.unsubscribeRate24h * 100)}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
